import React from "react";
import "./styles.scss";
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination, Navigation } from "swiper";
import Polishop from "../../images/logos/polishop.jpg";
import Fastshop from "../../images/logos/fast-shop.jpg";
import Centauro from "../../images/logos/centauro.jpg";
import Decathlon from "../../images/logos/decathlon.jpg";
import Marisa from "../../images/logos/marisa.jpg";
import Netshoes from "../../images/logos/netshoes.jpg";
import Dafiti from "../../images/logos/dafiti.jpg";
import PetLove from "../../images/logos/petlove.jpg";
import OticasDiniz from "../../images/logos/oticas-diniz.jpg";
import Mobly from "../../images/logos/mobly.jpg";
import Drogasil from "../../images/logos/drogasil.jpg";
import MadeiraMadeira from "../../images/logos/madeira-madeira.jpg";
import Etna from "../../images/logos/etna.jpg";
import Sephora from "../../images/logos/sephora.jpg";

import { StoreItem } from "../StoreItem";
import { useBreakpoint } from "../../hooks/useBreakpoint";

SwiperCore.use([Pagination, Navigation]);

interface CarouselProps {}

function Carousel({}: CarouselProps) {
  const storeList = [
    {
      name: "Polishop",
      altImage: "Polishop",
      urlImage: Polishop,
      src: "https://www.polishop.com.br/",
    },
    {
      name: "Fastshop",
      altImage: "Fastshop",
      urlImage: Fastshop,
      src: "https://www.fastshop.com.br/",
    },
    {
      name: "Centauro",
      altImage: "Centauro",
      urlImage: Centauro,
      src: "https://www.centauro.com.br/",
    },
    {
      name: "Decathlon",
      altImage: "Decathlon",
      urlImage: Decathlon,
      src: "https://www.decathlon.com.br/",
    },
    {
      name: "Marisa",
      altImage: "Marisa",
      urlImage: Marisa,
      src: "https://www.marisa.com.br/",
    },
    {
      name: "Netshoes",
      altImage: "Netshoes",
      urlImage: Netshoes,
      src: "https://www.netshoes.com.br/",
    },
    {
      name: "Dafiti",
      altImage: "Dafiti",
      urlImage: Dafiti,
      src: "https://www.dafiti.com.br/",
    },
    {
      name: "Pet love",
      altImage: "Pet love",
      urlImage: PetLove,
      src: "https://www.petlove.com.br/",
    },
    {
      name: "Óticas Diniz",
      altImage: "Óticas Diniz",
      urlImage: OticasDiniz,
      src: "https://www.oticasdiniz.com.br/",
    },
    {
      name: "Mobly",
      altImage: "Mobly",
      urlImage: Mobly,
      src: "https://www.mobly.com.br/",
    },
    {
      name: "Drogasil",
      altImage: "Drogasil",
      urlImage: Drogasil,
      src: "https://www.drogasil.com.br/",
    },
    {
      name: "Madeira Madeira",
      altImage: "Madeira Madeira",
      urlImage: MadeiraMadeira,
      src: "https://www.madeiramadeira.com.br/",
    },
    {
      name: "Etna",
      altImage: "Etna",
      urlImage: Etna,
      src: "https://www.etna.com.br/",
    },
    {
      name: "Sephora",
      altImage: "Sephora",
      urlImage: Sephora,
      src: "https://www.sephora.com.br/",
    },
  ];

  const { width } = useBreakpoint();

  return (
    <Swiper
      slidesPerView={width >= 768 ? 4 : 2}
      spaceBetween={width >= 768 ? 30 : 10}
      loop={true}
      loopFillGroupWithBlank={true}
      pagination={{
        clickable: true,
      }}
      navigation={true}
      className="mySwiper"
    >
      {storeList.map(({ altImage, name, src, urlImage }, index) => (
        <SwiperSlide key={name}>
          <StoreItem
            key={src}
            altImage={altImage}
            urlImage={urlImage}
            href={src}
            target="_blank"
            rel="noreferrer noopener"
            id={`lojaCarousel${index + 1}`}
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
}

export { Carousel };
